module.exports = __webpack_public_path__ + "img/text.573ad2bf.png";